// A share's timeline on its own: the share's events, read over its live
// socket while it is shown — a machine's workbench shows its agents' turns
// so (RFC-057 D6), where the share's page is the terminal.
import { useEffect, useMemo, useReducer } from "react";
import { wsURL, type ShareDetail, type User } from "../api";
import { LiveConnection, type SocketLike } from "../live";
import type { Envelope, Kind } from "../protocol";
import { t } from "../i18n";
import { applyFrame, buildTimeline, emptySession, namesOf } from "../timeline";
import { Timeline } from "./Timeline";

export function ShareTimeline({ share, me, socket }: { share: ShareDetail; me: User; socket?: (url: string) => SocketLike }) {
  const [state, dispatch] = useReducer((s: typeof emptySession, e: Envelope) => applyFrame(s, e), emptySession);
  useEffect(() => {
    const c = new LiveConnection({
      url: (since) => wsURL(`/v1/shares/${encodeURIComponent(share.id)}/ws?since=${since}`),
      me: { kind: share.role as Kind, user: me.id },
      share: share.id,
      onFrame: dispatch,
      onState: () => {},
      onBadFrame: (err) => console.warn("share: refused a frame", err),
      socket,
    });
    c.start();
    return () => c.stop("left");
  }, [share.id, share.role, me.id, socket]);
  const turns = useMemo(() => buildTimeline(state.events), [state.events]);
  const names = useMemo(() => namesOf(share.owner, state.participants, me), [share.owner, state.participants, me]);
  return <Timeline turns={turns} names={names} empty={share.backlog_floor ? t("session:noEventsKept") : t("workbench:timelineEmpty")} />;
}
